<template>
  <v-row class="border my-6" no-gutters>
    <v-col cols="6">
      <v-row align="center" class="fill-height" no-gutters>
        <v-col cols="3">
          <v-icon class="border pa-2 ml-4">{{ icon }}</v-icon>
        </v-col>
        <v-col cols="9" class="mt-4">
          <p justify="center">
            {{ behaviourComponent }}
          </p>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="6" class="pr-3">
      <v-row class="d-flex justify-center">
        <v-col align="center">
          <p :class="['border', 'pa-4', 'my-2', 'status', 'status-'+colorClass((behaviourChange.color ? behaviourChange.color : null))]">
            {{ getLabelForBehaviourChange(behaviourChange) }}
          </p>
        </v-col>
        <v-col align="center">
          <p :class="['border', 'pa-4', 'my-2', 'status', 'status-'+colorClass((behaviourChange.motivationColor ? behaviourChange.motivationColor : null))]">
            {{
              behaviourChange.motivationValue ? behaviourChange.motivationValue : $t('journeyOutcomeGoals.undefined')
            }}
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>


<script>
/**
 * Component GoalSettingBehaviourChangeGoalStatus.vue
 *
 * @module GoalSettingBehaviourChangeGoalStatus
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/components/Parts/GoalSettingBehaviourChangeGoalStatus.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "GoalSettingBehaviourChangeGoalStatus",
  props: {
    behaviourComponent: {
      type: String,
    },
    icon: {
      type: String,
    },
    behaviourChange: {
      type: Object,
    },
  },
  methods: {
    colorClass: (color) => {
      const defaultColor = 'null';
      return color ? color.toLowerCase() : defaultColor;
    },
    getLabelForBehaviourChange(behaviourChange) {
      if (behaviourChange.label) {
        if (behaviourChange.key == 'SMOKECESSATION') {
          if (behaviourChange.value == 'active_smoker') {

            return this.$ucfirst(this.$t('smokingRiskProfile.activeSmoker',
                {
                  params: {
                    dependence: this.$t(behaviourChange.extraInformation.dependence)
                  }
                }
            ));
          } else {
            return behaviourChange.label;
          }
        } else {
          return behaviourChange.label
        }
      } else {
        return this.$t('journeyOutcomeGoals.undefined');
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../scss/colors";
.status {
  min-height: 60px;
  color: black;
  border: none !important;
  line-height: 1.7;
}
</style>

<style lang="scss">
@import "../../../../scss/colors";

.status-null {
  background-color: #dedede;
}

.status-darkred {
  background-color: #{map-get($coroColors, status-darkred)}
}

.status-red {
  background-color: #{map-get($coroColors, status-red)}
}

.status-green {
  background-color: #{map-get($coroColors, status-green)}
}

.status-orange {
  background-color: #{map-get($coroColors, status-orange)}
}

.status-yellow {
  background-color: #{map-get($coroColors, status-yellow)}
}

.status {
  min-height: 60px;
  color: black;
  border: none !important;
  line-height: 1.7;
}
</style>
